/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

export const ERROR_TAXES = 'ERROR_TAXES';
export const RECEIVED_TAXES = 'RECEIVED_TAXES';
export const REQUESTED_TAXES = 'REQUESTED_TAXES';

export const errorTaxes = (error) => ({
  type: ERROR_TAXES,
  error
});

export const receivedTaxes = (response) => ({
  type: RECEIVED_TAXES,
  payload: {
    ...response
  }
});

export const requestedTaxes = () => ({
  type: REQUESTED_TAXES
});

export const SELECT_TAX_TABLE_FILTER = 'SELECT_TAX_TABLE_FILTER';

export const selectTaxFiltering = (selection) => ({
  type: SELECT_TAX_TABLE_FILTER,
  payload: { selection }
});

export const SELECT_COLLEGE_SAVINGS_FILTER = 'SELECT_COLLEGE_SAVINGS_FILTER';

export const selectCollegeSavingsFilter = (selection) => ({
  type: SELECT_COLLEGE_SAVINGS_FILTER,
  payload: { selection }
});

export const UPDATE_COST_BASIS_METHOD = 'UPDATE_COST_BASIS_METHOD';
export const updateCostBasisMethod = (accountId, costBasisTypeId) => ({
  type: UPDATE_COST_BASIS_METHOD,
  accountId,
  costBasisTypeId
});

export const RESET_COST_BASIS_METHOD = 'RESET_COST_BASIS_METHOD';
export const resetCostBasisMethod = (costBasisElections) => ({
  type: RESET_COST_BASIS_METHOD,
  costBasisElections
});

export const ERROR_UPDATE_COST_BASIS_METHOD = 'ERROR_UPDATE_COST_BASIS_METHOD';
export const errorUpdateCostBasisMethod = () => ({
  type: ERROR_UPDATE_COST_BASIS_METHOD
});
